import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import { postCompany, putCompany } from "../../helpers/backend_helper";
import NibbleInput from "../../components/Fields/NibbleInput";

const AddUpdModal = ({ modal, setModal, company, refreshCompanies }) => {
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...company },
    validationSchema: Yup.object({
      company_name: Yup.string().nullable(true).required("Requerido"),
      name: Yup.string().when("id", {
        is: (id) => !id,
        then: Yup.string().required("Nombre requerido"),
        otherwise: Yup.string(),
      }),
      email: Yup.string().when("id", {
        is: (id) => !id,
        then: Yup.string().email("Email inválido").required("Email requerido"),
        otherwise: Yup.string().email("Email inválido"),
      }),
      password: Yup.string().when("id", {
        is: (id) => !id,
        then: Yup.string()
          .min(6, "La contraseña debe tener al menos 6 caracteres")
          .required("Contraseña requerida"),
        otherwise: Yup.string(),
      }),
      password_confirm: Yup.string().when("id", {
        is: (id) => !id,
        then: Yup.string()
          .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
          .required("Confirmación de contraseña requerida"),
        otherwise: Yup.string(),
      }),
      phone: Yup.string().matches(/^[0-9]+$/, "Número de teléfono inválido"),
      local_phone: Yup.string().matches(
        /^[0-9]+$/,
        "Número de teléfono inválido"
      ),
    }),
    onSubmit: async (values) => {
      save(values);
    },
  });

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const save = (company) => {
    setLoading(true);
    if (modal.update) {
      putCompany(company).then((response) => {
        responseAction(response);
      });
    } else {
      postCompany(company).then((response) => {
        responseAction(response);
      });
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      handleClose();
      refreshCompanies();
    }
    setLoading(false);
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar " : "Agregar "}Empresa
        </ModalHeader>
        <ModalBody>
          <Form
            className="custom-form"
            onSubmit={(e) => {
              console.log("Entro al submit");
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            id="company-form"
          >
            <div className="row">
              <NibbleInput
                md={12}
                label="Nombre empresa:"
                fieldName="company_name"
                fieldType="text"
                validation={validation}
              />
            </div>
            {!company.id ? (
              <div className="row">
                <div className="col col-md-12 pt-4">
                  <h5>Datos de reseller</h5>
                </div>
                <NibbleInput
                  md={6}
                  label="Nombre:"
                  fieldName="name"
                  fieldType="text"
                  validation={validation}
                />
                <NibbleInput
                  md={6}
                  label="Email:"
                  fieldName="email"
                  fieldType="email"
                  validation={validation}
                />
                <NibbleInput
                  md={6}
                  label="Teléfono celular:"
                  fieldName="phone"
                  fieldType="text"
                  validation={validation}
                />
                <NibbleInput
                  md={6}
                  label="Teléfono local:"
                  fieldName="local_phone"
                  fieldType="text"
                  validation={validation}
                />
                <NibbleInput
                  md={6}
                  label="Contraseña:"
                  fieldName="password"
                  fieldType="password"
                  validation={validation}
                />
                <NibbleInput
                  md={6}
                  label="Repetir contraseña:"
                  fieldName="password_confirm"
                  fieldType="password"
                  validation={validation}
                />
              </div>
            ) : null}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            form="company-form"
            type="submit"
            color="primary"
            disabled={loading}
          >
            {loading && <Spinner size="sm"></Spinner>}
            Guardar
          </Button>{" "}
          <Button color="secondary" onClick={handleClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
